import { useState } from 'react';
import { deleteProductionCalendarDate } from 'services/api';
import type { CalendarEvent } from 'features/production-calendar/components/List/model/types';

interface UseDeleteModalProps {
  hide: () => void;
  onItemDelete: () => void;
  calendarEvent: CalendarEvent | null;
}

export const useDeleteModal = ({ hide, onItemDelete, calendarEvent }: UseDeleteModalProps) => {
  const [loading, setLoading] = useState(false);

  const hideModal = () => {
    hide();
  };

  const onSubmit = () => {
    setLoading(true);
    deleteProductionCalendarDate(calendarEvent!.id)
      .then(() => {
        hideModal();
        onItemDelete();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    state: { loading },
    methods: { hideModal, onSubmit },
  };
};
